import { useState, useEffect } from "react";
import Election from "./component";
import { ErrorBoundaryHoc } from "../ErrorBoundary/component";
import { useSelector } from "react-redux";
import { REFRESH_TIME } from "./constants";
const mapRegion = (state) => {
    if (state && typeof state.featureflags == "object") {
        const id = "election.region";
        const flags = Object.keys(state.featureflags);
        return flags
            .filter((flag) => flag.startsWith(id))
            .map((key) => {
                return {
                    //convert key to path e.g. "foo.bar" => "foo/bar"
                    path: key.replace(id, "").split(".").slice(1).join("/"),
                    value: state.featureflags[key],
                };
            });
    }
    return [];
};

const displaySet = new Set();

const displayLast = () => {
    let i = 0;
    displaySet.forEach((it) => {
        it(++i === displaySet.size);
    });
};

/**
 * A hook for displaying only the last instance.
 * @return {boolean} - the last instance will
 * return true, and the rest false.
 */

const useDisplayLast = () => {
    const [display, setDisplay] = useState(true);
    useEffect(() => {
        displaySet.add(setDisplay);
        displayLast();
        return () => {
            displaySet.delete(setDisplay);
            displayLast();
            return;
        };
    }, []);
    return display;
};

const FeatureToggle = (props) => {
    const regionList = useSelector(mapRegion);
    const display = useDisplayLast();
    const region = regionList.find(({ path }) => path === props.path);
    if (region && region.value && display) {
        return (
            <Election
                province={region.value}
                trackingLinkTitle={region.value}
                interval={REFRESH_TIME}
            />
        );
    }
    return null;
};

export const OnElectionHide = (props) => {
    const regionList = useSelector(mapRegion);
    const region = regionList.find(({ path }) => path === props.path);
    if (region && region.value) {
        return null;
    }
    return props.children || null;
};

export default ErrorBoundaryHoc(FeatureToggle);
